'use client'
import { t } from 'i18next';
import { ContentHeader } from "../layout/ContentHeader"

function AccountPage() {
    return (
        <div>
            <ContentHeader title={t('account')} />
        </div>
    )
}

export default AccountPage